import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import Slider from 'react-slick';

import {diamondImgUrl, diamondTitle, diamondPrice} from '../../../../../../utils/formatting';
import {getMinPrice} from '../../../../../../utils/product';
import {cloneArray} from '../../../../../../utils/data';

import * as productActionCreators from '../../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import {ResultsControlsContainer} from '../ResultsControls';
import {ResultsPaginationContainer} from '../ResultsPagination';
import RhinoLoading from '../../../../common/RhinoLoading';

class SettingGrid extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {

    super(props);
    this.state = {
      scrollPos: 0,
    };

    // Bind event listeners
    this.getScrollPos = ::this.getScrollPos;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.getScrollPos, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.getScrollPos, false);
  }

  getScrollPos() {
    this.setState({
      scrollPos: window.pageYOffset,
    })
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  selectSetting(product) {
    this.props.productSelectSetting(product);
  }

  isSettingSelected() {
    return this.props.product.selectedSetting !== null;
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  isFavoriteProduct(product) {
    if(!product) {
      return false;
    }

    for(let i = 0; i < this.props.product.compareSettings.length; i++) {
      if(this.props.product.compareSettings[i].sku == product.sku) {
        return true;
      }
    }
    return false;
  }

  toggleFavoriteProduct(product) {
    if(this.isFavoriteProduct(product)) {
      this.removeFavoriteProduct(product);
    } else {
      this.addFavoriteProduct(product);
    }
  }

  addFavoriteProduct(product) {
    let faves = cloneArray(this.props.product.compareSettings);
    if(faves.length >= 4) {
      return;
    }
    faves.push(product);
    this.props.productCompareSetting(faves);
    this.setState({ 
      upperTabSelected: 'picks',
    });
  }

  removeFavoriteProduct(product) {
    
    let currentIndex = null;
    let faves = cloneArray(this.props.product.compareSettings);

    if(this.props.product.compareSettings.length === 1) {
      this.props.productCompareSetting([]);
      return;
    }

    for(let i = 0; i < faves.length; i++) {
      if(faves[i].sku == product.sku) {
        currentIndex = i;
        break;
      }
    }

    faves.splice(currentIndex, 1);
    this.props.productCompareSetting(faves);
  }

  prevPage() {
    this.props.productSetPage(parseInt(this.props.product.currentPage) - 1);
    this.props.scrollUp();
  }

  nextPage() {
    this.props.productSetPage(parseInt(this.props.product.currentPage) + 1);
    this.props.scrollUp();
  }

  setPage(pageNum) {
    this.props.productSetPage(parseInt(pageNum));
    this.props.scrollUp();
  }

  isMobile() {
    return window.innerWidth <= 1024;
  }

  getPageCount() {
    return this.isMobile() ? 24 : 23;
  }

  getSettingResults() {

    const AD_POSITION = 4;

    let resultsArray = [];

    if(!this.props.product.productResults || this.props.product.productResults.length === 0) {
      return resultsArray;
    }

    for(let i = 0; i < this.props.product.productResults.length; i++) {

      if(i >= this.getPageCount() * this.props.product.currentPage) {
        break;
      }

      if(i < this.getPageCount() * (this.props.product.currentPage - 1)) {
        continue;
      }

      if(!this.isMobile() && resultsArray.length == AD_POSITION) {
        resultsArray.push({sku: 'ad'});
      }

      resultsArray.push(this.props.product.productResults[i]);
    }

    return resultsArray;
  }

  renderProductAd(keyNum) {

    return <div className={'productBannerItem adBannerItem'} key={keyNum} onClick={() => this.internalNav('engagement-rings')}>
      <div className={'adInnerWrapper engagementAd'}>
        <div className='adPrompt'><div>Browse Top Styles &gt;</div></div>
      </div>
    </div>
  }

  render() {

    const RESULT_LIMIT = 24;
    let pCount = 0;

    return <div className='SettingGrid'>
      <ResultsControlsContainer
        resultCount={this.props.product.productResultsCount}
        resultType={'setting'}
        openFilters={this.props.openFilters} />
      <div className='resultItemsWrapper'>
        {this.props.product.productResults && this.props.product.productResults.length > 0 ?
          <div>
            {this.getSettingResults().map((product, j) => {
            
              // if(product.image_count === 0 || pCount >= RESULT_LIMIT * this.props.product.currentPage) {
              //   return null;
              // }

              // if(pCount < RESULT_LIMIT * (this.props.product.currentPage - 1)) {
              //   pCount++;
              //   return null;
              // }

              if(product.sku == 'ad') {
                return this.renderProductAd(j);
              }

              pCount++;

              return <div className={'productBannerItem'} key={j}>
                <div className='productItemInnerWrapper'>
                  <Link to={'/setting/' + product.sku}>
                    <div className='diamondItemImgWrapper'>
                      <img src={this.getProductMainImage(product)} />
                    </div>

                    <div className='productItemTitle'>
                      <div>{product.name.replace(/Ã©/g, 'é')}</div>
                    </div>

                    <div className='diamondItemPrice'>
                      ${getMinPrice(product).toLocaleString()}
                    </div>
                  </Link>
                  {this.props.product.selectedSetting && product.sku === this.props.product.selectedSetting.sku ?
                    <div className={'diamondItemAction mixedResultsButton selected'}>Selected</div> :
                    <div className={'diamondItemAction mixedResultsButton'} onClick={() => this.selectSetting(product)}>Choose Setting</div>
                  }
                  <div className='favSelectWrapper' onClick={() => this.toggleFavoriteProduct(product)}>
                    {this.isFavoriteProduct(product) ? 
                      <img src='https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare_a.svg' /> :
                      <img src='https://ddw2.diamondsdirect.com/img/gallery/results/picks/compare.svg' />
                    }
                  </div>
                </div>
              </div>
            })}
            <ResultsPaginationContainer
              pageNum={parseInt(this.props.product.currentPage)}
              pageNext={::this.nextPage}
              pagePrev={::this.prevPage}
              setPage={::this.setPage}
              pageSize={this.getPageCount()}
              resultCount={pCount} />
          </div> :
          <RhinoLoading />
        } 
      </div>
    </div>;
  }
}
export default SettingGrid;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const SettingGridContainer = connect(
  mapStateToProps,
  allActionCreators
)(SettingGrid);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/results/grids/SettingGrid.jsx